import React, {useEffect, useState} from 'react';
import {Modal, Button, Form, Row, Col, Card, Table, Badge, Dropdown, Pagination, FormSelect,} from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import FormControl from "../../../shared/components/FormControl";
import {businessYearService} from "../../../services/businessYearService";
import eventEmitter from "../../../shared/eventEmitter";
import {EventEmitterTypes} from "../../../shared/eventEmitterEnum";
import notificationService from "../../../services/NotificationService";
import NotificationService from "../../../services/NotificationService";
import FormSelectCustom from "../../../shared/components/FormSelectCustom";
import {states} from "../../../shared/StatesDropdown";
import {AreaSchedule} from "../AreaSchedulesCard";
import {dayColumns} from "../../../shared/DaysOfTheWeek";

interface AreaSchedulesModalProps {
    details?: AreaSchedule;
    year: number;
    show: boolean;
    toggle: () => void;
}




const AreaSchedulesModal: React.FC<AreaSchedulesModalProps> = ({details, year, show, toggle}) => {
    const [name, setName] = useState<string>('');
    const [type, setType] = useState<string>('');
    const [id, setId] = useState<string>('');
    const [activeDaysOfWeek, setActiveDaysOfWeek] = useState<number>(0);
    const [state, setState] = useState<string>('');
    const [showErrors, setShowErrors] = useState(false);

    function handleSave() {
        let postData = {
            dayOfWeekFlags: activeDaysOfWeek,
            city: null,
            county: null,
            postalCode: null,
            ...(details ? { areaScheduleId: details.areaScheduleId } : {}),
            state: state,
        }
        if(type === 'City'){
            postData.city = name
        }
        if(type === 'County'){
            postData.county = name
        }
        if(type === 'PostalCode'){
            postData.postalCode = name
        }
        if(details){
            businessYearService.updateAreaSchedule(postData, year).then(r => {
                eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_AREA_SCHEDULES)
                toggle();
            })
        } else {
            businessYearService.createAreaSchedule(postData, year).then(r => {
                eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_AREA_SCHEDULES)
                toggle();
            })
        }
        
    }
    useEffect(() => {
        if(details){
            if(details.city){
                setType('City')
                setName(details.city)
            }
            if(details.county){
                setType('County')
                setName(details.county)
            }
            if(details.postalCode){
                setType('PostalCode')
                setName(details.postalCode + '')
            }
            setId(details.areaScheduleId)
            setActiveDaysOfWeek(details.dayOfWeekFlags)
            setState(details.state)
        } else {
            setType('');
            setName('');
            setId(null)
            setActiveDaysOfWeek(0)
            setState('')
        }
        
    }, [details]);

    const toggleDay = (flag: number) => {
        setActiveDaysOfWeek((prev) => prev ^ flag);
    };
    
    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <h5 className="modal-title" id="profileModalTitle">Area Schedules</h5>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row gx-3">
                        <Form.Group controlId="isFixedPrice" className="col-md-6 mb-3">
                            <Form.Label>Type<sup className="text-danger">*</sup></Form.Label>
                            <Form.Select
                                aria-label="isFixedPrice"
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                required
                            >
                                <option value="">Select</option>
                                <option value="City">City</option>
                                <option value="County">County</option>
                                <option value="PostalCode">Zip</option>
                            </Form.Select>
                            {showErrors && type === '' &&
                                <div className="invalid-feedback">
                                    This field is required.
                                </div>
                            }
                        </Form.Group>
                    </div>
                    <div className="row gx-3">
                        <Form.Group controlId="Name" className="col-md-6 mb-3">
                            <FormControl
                                type="text"
                                label={"Area Name"}
                                value={name}
                                placeholder='Name'
                                showErrors={showErrors}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <div className="col-md-6 mb-3">
                            <Form.Label>State<sup className="text-danger">*</sup></Form.Label>
                            <Form.Select
                                aria-label="state"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                required
                            >
                                <option value="">Select</option>
                                {states.map(state => {
                                    return (<option value={state.label}>{state.label}</option>);
                                })}
                            </Form.Select>
                        </div>
                    </div>
                    <div className="row gx-3">
                        <div className="col-12">
                            <label className="d-block mb-2 fw-medium">Available to schedule<sup
                                className="text-danger">*</sup></label>
                            {dayColumns.map((day) => (
                                <div key={day.flag}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={Boolean(activeDaysOfWeek & day.flag)}
                                            onChange={() => toggleDay(day.flag)}
                                        />
                                        {day.name}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary text-strong text-uppercase m-100" onClick={handleSave}>
                    Save
                </Button>
                <Button className="btn btn-cancel text-strong text-uppercase m-100" onClick={toggle}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AreaSchedulesModal;
